export const GEOCODING_URL = 'https://api.mapbox.com/search/geocode/v6/forward';

export const RESULT_LIMIT = 5;
